import { Language } from '@backoffice-frontend/common'
import type { Maybe, RioCategory, RioLabel } from '@backoffice-frontend/graphql'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export type TRio = (label: Maybe<RioLabel> | undefined) => string

export const useRioTranslation = (): TRio => {
  const { i18n } = useTranslation()

  return useCallback(
    (label: Maybe<RioLabel> | undefined) => {
      const translation = i18n.language === Language.de ? label?.de : label?.en
      return translation ?? ''
    },
    [i18n.language],
  )
}

export const useCategoryTranslation = () => {
  const { t } = useTranslation()

  return (key: RioCategory): string => {
    const options: Record<string, string> = {
      Accident: t('common_accident_label'),
      VehicleChecks: t('reportIOLib_vehicleChecks_label'),
      Disruption: t('common_disruption_label'),
    }
    return options[key] ?? key
  }
}
